import { render, staticRenderFns } from "./TwSavePattern.vue?vue&type=template&id=0e22a3d9&"
import script from "./TwSavePattern.vue?vue&type=script&lang=js&"
export * from "./TwSavePattern.vue?vue&type=script&lang=js&"
import style0 from "./TwSavePattern.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports